import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import styles from './DownloadAnimate.module.less';
import Lottie from 'lottie-web';
import animationData from '../../utils/downAnimate.json';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);
// const DownLoadStatus = {
//   pre: '准备中',
//   wait: '等待中',
//   pause: '下载已暂停，点击继续',
//   dl: '下载中',
//   err: '任务异常',
//   i: '安装中...',
//   exitq: '任务结束',
// };
export default memo(() => {
  const [node, setNode] = useState(null);
  const lottieInstaceRef = useRef(null);
  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
  const [downloadCount, setDownLoadCount] = useState(0);
  const [downloadStatus, setDownLoadStatus] = useState('stop'); //stop 默认停止动画 start开始动画 pause暂停
  const [hasErr, setHasErr] = useState(false);
  const startTimer = useRef(null);
  const endTimer = useRef(null);

  const stopAnimate = useCallback(() => {
    if (endTimer.current) {
      clearTimeout(endTimer.current);
    }
    if (startTimer.current) {
      clearTimeout(startTimer.current);
      startTimer.current = null;
    }
    if (lottieInstaceRef.current) {
      lottieInstaceRef.current.resetSegments(true);
      lottieInstaceRef.current.goToAndPlay(134, true);
      endTimer.current = setTimeout(() => {
        lottieInstaceRef.current.stop();
        clearTimeout(endTimer.current);
        endTimer.current = null;
      }, 1480);
    }
  }, []);

  const startAnimate = useCallback(() => {
    if (startTimer.current) {
      lottieInstaceRef.current.play();
    } else {
      lottieInstaceRef.current.goToAndPlay(0, true);
      clearTimeout(startTimer.current);
      startTimer.current = setTimeout(() => {
        lottieInstaceRef.current.playSegments([43, 66], true);
        clearTimeout(startTimer.current);
        startTimer.current = null;
      }, 1720);
    }
  }, []);
  const pauseAnimate = useCallback(() => {
    if (lottieInstaceRef.current.firstFrame !== 43) {
      lottieInstaceRef.current.playSegments([43, 66], true);
    }
    clearTimeout(startTimer.current);
    startTimer.current = null;
    if (lottieInstaceRef.current.firstFrame < 43 || lottieInstaceRef.current.firstFrame > 66) {
      lottieInstaceRef.current.goToAndStop(43, true);
    } else {
      lottieInstaceRef.current.goToAndStop(lottieInstaceRef.current.currentFrame, true);
    }
  }, []);
  const handleSoftCount = useCallback(() => {
    if (downloadCount > 0 && hasErr) {
      return require(`../../static/download_error.svg`)?.default;
    }
    if (downloadCount > 0 && downloadCount < 10) {
      return require(`../../static/${'download_count' + downloadCount + '.svg'}`);
    } else if (downloadCount > 0) {
      return require(`../../static/download_count.svg`);
    }
    return null;
  }, [hasErr, downloadCount]);

  const initAnimation = () => {
    const lottieInstace = Lottie.loadAnimation({
      container: node, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: false,
      autoloadSegments: false,
      animationData: animationData,
      name: 'download',
    });
    lottieInstaceRef.current = lottieInstace;
  };

  useEffect(() => {
    if (node) {
      initAnimation();
    }
  }, [node]);

  useEffect(() => {
    // 过滤掉退出状态的软件
    if (downloadSofts && downloadSofts.length) {
      const filterCompeleteSoft = downloadSofts.filter(soft => {
        return soft.attr.status !== 'exitq';
      });
      setDownLoadCount(filterCompeleteSoft.length);
    } else {
      setDownLoadCount(0);
    }
  }, [downloadSofts]);
  useEffect(() => {
    // 判断动画状态
    // 判断是否含有进行中状态
    if (downloadSofts && downloadSofts.length > 0) {
      const status = {
        pre: true,
        wait: true,
        dl: true,
        i: true,
      };
      const hasdownLoading = downloadSofts.find(soft => status[soft.attr.status]);
      if (hasdownLoading) {
        setDownLoadStatus('start');
        setHasErr(false);
        return;
      }
    }
    // 判断是否有异常
    if (downloadSofts && downloadSofts.length > 0) {
      const status = {
        err: true,
      };
      const hasError = downloadSofts.find(soft => status[soft.attr.status]);
      if (hasError) {
        setDownLoadStatus('stop');
        setHasErr(true);
        return;
      }
    }
    // 判断是所有暂停
    if (downloadSofts && downloadSofts.length > 0) {
      const status = {
        pause: true,
      };
      const targetSofts = downloadSofts.filter(soft => soft.attr.status !== 'exitq');
      const allPause = targetSofts.every(soft => status[soft.attr.status]);
      if (targetSofts && targetSofts.length > 0 && allPause) {
        setDownLoadStatus('pause');
        setHasErr(false);
        return;
      }
    }
    setHasErr(false);
    setDownLoadStatus('stop');
  }, [downloadSofts]);

  useEffect(() => {
    if (downloadStatus === 'start' && lottieInstaceRef && lottieInstaceRef.current) {
      startAnimate();
    } else if (downloadStatus === 'pause' && lottieInstaceRef && lottieInstaceRef.current) {
      pauseAnimate();
    } else {
      stopAnimate();
    }
  }, [downloadStatus]);

  return (
    <div className={`${styles.animate_container}`}>
      <div ref={r => setNode(r)} style={{ opacity: downloadStatus === 'stop' ? 0 : 1 }} />
      {downloadSofts && downloadSofts.length > 0 && (
        <img src={handleSoftCount()} alt="" className={styles.animate_count} />
      )}
      {downloadStatus === 'stop' && (
        <i className={`iconfont icon-opt_download ${styles.download_icon}`} />
      )}

      <div className={styles.animate_container_modal} />
    </div>
  );
});
